export const jobsReports = {
  id: 'jobs',
  name: 'Jobs',
  description: '',
  visibility: 'private',
  subject_type: 'jobs',
  layout: {
    data: [
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '4795',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '4796',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '4797',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '4798',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 24,
        w: 12,
        x: 0,
        y: 7,
        key: '4799',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 31,
        key: '4800',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 31,
        key: '4801',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 54,
        key: '4802',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4795,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_opened',
        tileKey: 'jobs_opened',
        apiParam: 'card',
        headerKey: 'opened_jobs',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4796,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_closed',
        tileKey: 'jobs_closed',
        apiParam: 'card',
        headerKey: 'closed_jobs',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4797,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_time_to_close',
        unit: 'time',
        tileKey: 'jobs_time_to_close',
        apiParam: 'card',
        // headerKey: 'time_to_close',
        componentType: 'card',
        calculationType: 'avgChange',
        metricKeys: {
          numerator: 'time_to_close',
          denominator: 'closed_jobs',
        },
      },
      query: null,
    },
    {
      id: 4798,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_target_breached',
        tileKey: 'jobs_target_breached',
        apiParam: 'card',
        headerKey: 'target_breached_jobs',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4799,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_trend_chart',
        tileKey: 'jobs_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_2: 'job_type',
        },
      },
      query: null,
    },
    {
      id: 4800,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_department_chart',
        tileKey: 'jobs_department_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'department',
        },
      },
      query: null,
    },
    {
      id: 4801,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_location_chart',
        tileKey: 'jobs_location_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'job_location',
        },
      },
      query: null,
    },
    {
      id: 4802,
      subject_type: 'jobs',
      metadata: {
        id: 'jobs_table',
        tileKey: 'jobs_table',
        apiParam: 'chart_table',
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
